module.exports = __webpack_public_path__ + "img/caja_medica.4e1aa056.png";